<template>
  <!-- <header class="bgimg-1 w3-display-container w3-grayscale-min" style="padding:250px 0px; margin: 0px 0px;" id="home"> -->
  <!-- <header class="header w3-display-container w3-grayscale-min" style="padding:300px 0px; top: 0px;" id="home"> -->
  <header class="bgimg-1 w3-display-container w3-grayscale-min" style="padding-top: 200px;margin-bottom: -100px;" id="home">
    <!-- <header class="bgimg-1 w3-display-container w3-grayscale-min" style="padding:300px 0px; top: 0px;" id="home"> -->
    <div class="w3-display-left w3-text-white" style="padding-left: 10%;margin-top: 100px; position:relative; z-index:2;">
      <span class="w3-jumbo w3-hide-small">
        <!-- <span class="w3-jumbo w3-hide-small content__title"> -->
        {{ $t('header.titleNose') }}
        <br>
        <UnderLiner :delay="500" bottom="5px">
          {{ $t('header.titleMid') }}
        </UnderLiner>
        <br>
        {{ $t('header.titleTail') }}
      </span><br>
      <span class="w3-xxxlarge w3-hide-large w3-hide-medium">
        {{ $t('header.titleNose') }}
        <br>
        <UnderLiner :delay="500" bottom="5px">
          {{ $t('header.titleMid') }}
        </UnderLiner>
        <br>
        {{ $t('header.titleTail') }}
      </span><br>
      <span class="w3-xlarge">{{ $t('header.subtitle1') }}</span>
      <span class="w3-xlarge">{{ $t('header.subtitle2') }}</span>
      <p>
        <!-- <a href="#about" class="w3-button w3-white w3-padding-large w3-large w3-margin-top w3-opacity w3-hover-opacity-off"> -->
        <a href="#contact"
          class="w3-button w3-padding-large w3-large w3-margin-top w3-opacity w3-hover-opacity-off w3-hover-red w3-gray"
          style="border-radius: 3px;z-index: 10;">
          <!-- <UnderLiner :delay="1500"> -->
          {{ $t('header.button') }}
          <!-- </UnderLiner> -->
        </a>
      </p>
    </div>
    <!-- <div style="top: 5%;right: 5%;left: -15%; position:absolute; z-index:1;">
      <div class="_useCaseCycle_1cl88_1 w3-hide-small">
        <div class="_browser3dwrapper_1cl88_202">
          <div class="_useCaseCycle__editor_1cl88_209">
            <div class="_useCaseCycle__editor__browser_1cl88_235">
              <div class="_useCaseCycle__editor__browser__tab_1cl88_242">
                <span style="color: rgba(255, 255, 255, .1);">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|k&lt;</span>
              </div>
            </div>
            <div class="_useCaseCycle__editor__address_1cl88_259"></div>
            <div class="_useCaseCycle__editor__editor_1cl88_264">
              <div class="_mockEditor_1cl88_271">
                <div class="_mockEditor__file_explorer_1cl88_281"></div>
                <div class="_mockEditor__code_1cl88_295">
                  <div class="_mockEditor__codeTerminal_1cl88_308"></div>
                </div>
                <div class="_mockEditor__preview_1cl88_323">
                  <div class="_mockEditor__codeConsole_1cl88_335"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="w3-display-bottomleft w3-text-grey w3-large" style="padding:24px 48px">
      <i class="fa fa-facebook-official w3-hover-opacity"></i>
      <i class="fa fa-instagram w3-hover-opacity"></i>
      <i class="fa fa-snapchat w3-hover-opacity"></i>
      <i class="fa fa-pinterest-p w3-hover-opacity"></i>
      <i class="fa fa-twitter w3-hover-opacity"></i>
      <i class="fa fa-linkedin w3-hover-opacity"></i>
    </div> -->
  </header>
</template>

<script>

import UnderLiner from './UnderLiner.vue';
//import reactImg from '../assets/react.svg';

export default {
  components: {
    UnderLiner
  },
  // data() {
  //   return {
  //     react: computed(function() {
  //       return reactImg
  //     })
  //   }
  // },
  name: 'HeaderSection'
}
</script>

<style>
.header {
  /* background: #07061a;
background: linear-gradient(144deg, rgba(7, 6, 26, 1) 0%, rgba(71, 6, 12, 1) 65%, rgba(31, 164, 191, 1) 100%); */
  background: #07061a;
  background: linear-gradient(144deg, rgba(7, 6, 26, 1) 0%, rgba(71, 6, 12, 0.83) 65%, rgba(31, 164, 191, 1) 100%);
  /* background: #710612, */

  /* background: #1A1D22;
background: linear-gradient(27deg, rgba(26, 29, 34, 1) 0%, rgba(2, 0, 36, 1) 66%, rgba(6, 2, 54, 1) 86%); */
  /* background: #1A1D22; */
  /* background: linear-gradient(27deg, rgba(26, 29, 34, 1) 0%, rgba(18, 18, 46, 1) 53%, rgba(6, 2, 54, 1) 86%); */
}
</style>